import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=4e6b1825&scoped=true&"
import script from "./BankInfo.vue?vue&type=script&lang=ts&"
export * from "./BankInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b1825",
  null
  
)

export default component.exports